import LightPopin from '@scripts/components/LightPopin';
import Observer from '@scripts/components/concerns/Observer';
import CvRiskHelpers from '@scripts/helpers';

/**
 * Confirmation popin
 */
export default class extends LightPopin {
  /**
   * Cancel button
   *
   * @private
   *
   * @type {?HTMLButtonElement}
   */
  #cancel;

  /**
   * Cancel button label
   *
   * @private
   *
   * @type {string}
   */
  #cancelLabel = '';

  /**
   * Confirm button
   *
   * @private
   *
   * @type {?HTMLButtonElement}
   */
  #confirm;

  /**
   * Confirm button label
   *
   * @private
   *
   * @type {string}
   */
  #confirmLabel = '';

  /**
   * @param {string} confirmLabel Confirm button label
   * @param {string} cancelLabel Cancel button label
   */
  constructor(confirmLabel = '', cancelLabel = '') {
    super();

    this.#cancelLabel = cancelLabel || CvRiskHelpers?.label('cancel') || '';
    this.#confirmLabel = confirmLabel || CvRiskHelpers?.label('confirm') || '';
  }

  _createPopin() {
    super._createPopin();

    // add 'cancel' and 'confirm' buttons

    const buttons = document.createElement('div');
    buttons.classList = 'cvrisk-popin-buttons';

    // cancel
    this.#cancel = document.createElement('button');
    this.#cancel.classList = 'cvrisk-popin-btn-cancel cvrisk-btn-sm';
    this.#cancel.innerText = this.#cancelLabel;
    buttons.appendChild(this.#cancel);
    this.#cancel.addEventListener('click', () => this.close());

    // confirm
    this.#confirm = document.createElement('button');
    this.#confirm.classList = 'cvrisk-popin-btn-confirm cvrisk-btn-sm';
    this.#confirm.innerText = this.#confirmLabel;
    buttons.appendChild(this.#confirm);
    this.#confirm.addEventListener('click', () =>
      this.notify({ confirm: true })
    );

    this._popin.querySelector('.cvrisk-popin-wrapper').appendChild(buttons);
    this._popin.classList.add('cvrisk-popin-confirm');
  }

  /**
   * @param {string} message Popin message
   *
   * @return {Promise<boolean>}
   */
  confirm(message) {
    return new Promise((resolve) => {
      // create observer
      const observer = new Observer();
      observer.update = (data) => {
        if (data.confirm !== undefined || data?.open === false) {
          this.unsubscribe(observer);
          resolve(data?.confirm === true);
        }
      };

      // register observer
      this.subscribe(observer);

      // open popin
      this.open(message);
    });
  }
}
